<template>
  <div class="drag-item" :draggable="!disabled" @dragstart.stop="ondragstart">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DragItem',
  components: {},
  props: {
    data: {
      type: [Object, Array, String, Number],
    },
    disabled: {
      type: Boolean,
    },
    indicatorInvisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    ondragstart(e: DragEvent) {
      // console.log('dragstart', e, this.data);
      e.dataTransfer?.setData('dnddata', JSON.stringify(this.data));
    },
  },
});
</script>

<style lang="scss">
.drag-item {
  display: flex;
  align-items: center;
  cursor: move;
  &:hover .drag-item-icon {
    visibility: visible !important;
  }
}
</style>
